/**
 * Emit debug values to inline markers in code snippets
 *
 * Finds elements with data-debug attributes matching the given id
 * and replaces their text content with the JSON-stringified value.
 */

import { tightJavaScriptify } from "@phosphor/utils";

export function emitDebugValue(id: `!${string}`, value: unknown): void {
  const elements = document.querySelectorAll(`[data-debug="${id}"]`);
  const jsonValue = tightJavaScriptify(value);

  elements.forEach((el) => {
    if (el instanceof HTMLElement) {
      el.textContent = jsonValue;
      el.classList.add("debug-value-emitted");
    }
  });
}
